import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Son savunma hattı: render/commit sırasında beklenmeyen bir hata olursa boş
 * sayfa yerine okunabilir bir hata yüzeyi gösterir. Özellikle eski TV
 * tarayıcılarında hata mesajını kullanıcıdan alabilmek için gereklidir.
 */
export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('pbfork arayüz hatası', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error === null) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          boxSizing: 'border-box',
          minHeight: '100vh',
          padding: '32px',
          background: '#0a0d12',
          color: '#e6edf3',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
          lineHeight: 1.5,
        }}
      >
        <h1 style={{ margin: '0 0 12px', fontSize: '24px' }}>pbfork açılamadı</h1>
        <p style={{ margin: '0 0 8px' }}>Beklenmeyen bir arayüz hatası oluştu.</p>
        <pre
          style={{
            maxWidth: '900px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            color: '#a8c0f0',
          }}
        >
          {this.state.error.message}
        </pre>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            marginTop: '12px',
            padding: '10px 16px',
            borderRadius: '8px',
            border: '1px solid #3b5bdb',
            background: '#3b5bdb',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Yenile
        </button>
      </div>
    );
  }
}
